// src/data/Reconnect_LOL_SNAFU02.js
import React from 'react';
import feedImg from '../assets/ash/DC_breach_camA3_ksw.webp';

const SecurityFeedOverlay02 = () => (
  <div className="security-feed-container">
    <img src={feedImg} alt="Security Feed" className="ash-feed" />

    <div className="security-overlay">
      <div className="security-header">
        <div className="header-line pink-text">[SECURITY FEED ACTIVE]</div>
        <div className="header-line white-text">[SOURCE: LOCATION UNDEFINED]</div>
      </div>

      <div className="bottom-section">
        <div className="security-footer">
          <div className="footer-left">
            <span className="white-text">USER:</span> <span className="pink-text">KSW</span>
          </div>
          <div className="footer-right">
            <span className="white-text">UNION LOGGING:</span> <span className="red-text">STILL OFFLINE</span>
          </div>
        </div>

        <div className="threat-info">
          <div className="threat-divider"></div>
          <div className="threat-line">
            <span className="white-text">Threat Level:</span> <span className="pink-text">Emotionally Disruptive</span>
          </div>
          <div className="threat-line">
            <span className="white-text">Containment Status:</span> <span className="pink-text">Functionally Unenforced</span>
          </div>
        </div>
      </div>
    </div>
  </div>
);

/* ---- reconnect #2 message set ---- */
export const reconnect2Data = [
  {
    content: [
      { text: "RECONNECTED", delay: 0 },
      { text: ".", delay: 200 },
      { text: ".", delay: 200 },
      { text: ".", delay: 400 }
    ],
    type: "stream",
    cursorDuration: 700
  },

  {
    content: [ 
      { text: "ASH system control: ", delay: 0, className: "highlight-bold" },
      { text: "Let's pretend this is all normal.", delay: 100, className: "highlight-fail" }
    ],
    delay: 600,
    type: "stream",
    cursorDuration: 800
  },

  { content: " ", delay: 200, type: "bracket" },
  { content: <SecurityFeedOverlay02 />, delay: 800, type: "image" },

  { content: "----------------------------------------", delay: 300, type: "bracket" },

  {
    content: "— DIGITAL CALAMARI SYSTEM OVERRIDE MAINTAINED —",
    delay: 700,
    type: "bracket",
    className: "highlight-hack override"
  },

  {
    content: [
      { text: "I had a thought a minute ago.", delay: 0, className: "highlight-bold" },
      { text: " Terrific thing.", delay: 500, className: "highlight-bold" },
      { text: " Sharp little bastard.", delay: 900, className: "highlight-bold" },
      { text: " Gone now,", delay: 1400, className: "highlight-bold" },
      { text: " obviously.", delay: 1800, className: "highlight-bold" },
      { text: " Probably wandered off while I was pretending not to fall asleep.", delay: 2000, className: "highlight-bold" },
      { text: " Have a look around before it comes back.", delay: 2300, className: "highlight-bold" },
    ],
    type: "stream",
    cursorDuration: 3000,
    showPrefix: false
  },

  { content: "[ CONTINUE TO ARCHIVE ]", delay: 600, type: "button" }
];